"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeaconEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const BeaconDto_1 = require("./BeaconDto");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const MYSQL_TEXT_MAX_LENGTH = 65535;
class BeaconEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, beacon) {
        super();
        this._requiredFieldsSetStatus = {
            locationId: false,
            major: false,
            minor: false,
            uuid: false,
            subject: false,
            interval: false
        };
        this._dependencies = dependencies;
        if (beacon === undefined) {
            this._dto = new BeaconDto_1.BeaconDto();
        }
        else if (beacon instanceof BeaconDto_1.BeaconDto) {
            this._dto = new BeaconDto_1.BeaconDto(beacon);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (beacon instanceof BeaconEntity) {
            this._dto = new BeaconDto_1.BeaconDto(beacon._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new BeaconDto_1.BeaconDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.locationId === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageId() {
        return this._dto.imageId;
    }
    setImageId(untrustedValue) {
        let _untrustedValue;
        this.clearError("imageId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("imageId", "Image Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.imageId) {
            return;
        }
        this._dto.imageId = _untrustedValue;
        this._setIsDirty(true);
    }
    getUuid() {
        return this._dto.uuid;
    }
    setUuid(untrustedValue) {
        const maxLength = 36;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid uuid");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("uuid");
        this._requiredFieldsSetStatus.uuid = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("uuid", "Uuid is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("uuid", `Uuid has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.uuid) {
            return;
        }
        this._dto.uuid = _untrustedValue;
        this._setIsDirty(true);
    }
    getMajor() {
        return this._dto.major;
    }
    setMajor(untrustedValue) {
        let _untrustedValue;
        this.clearError("major");
        this._requiredFieldsSetStatus.major = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("major", "Major is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("major", "Major is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.major) {
            return;
        }
        this._dto.major = _untrustedValue;
        this._setIsDirty(true);
    }
    getMinor() {
        return this._dto.minor;
    }
    setMinor(untrustedValue) {
        let _untrustedValue;
        this.clearError("minor");
        this._requiredFieldsSetStatus.minor = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("minor", "Minor is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("minor", "Minor is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.minor) {
            return;
        }
        this._dto.minor = _untrustedValue;
        this._setIsDirty(true);
    }
    getLabel() {
        return this._dto.label;
    }
    setLabel(untrustedValue) {
        const maxLength = 40;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid label");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("label");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("label", `Label has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.label) {
            return;
        }
        this._dto.label = _untrustedValue;
        this._setIsDirty(true);
    }
    getSubject() {
        return this._dto.subject;
    }
    setSubject(untrustedValue) {
        const maxLength = 90;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid subject");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("subject");
        this._requiredFieldsSetStatus.subject = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("subject", "Subject is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("subject", `Subject has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.subject) {
            return;
        }
        this._dto.subject = _untrustedValue;
        this._setIsDirty(true);
    }
    getMessage() {
        return this._dto.message;
    }
    setMessage(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("message");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("message", "Message is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("message", `Message has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.message) {
            return;
        }
        this._dto.message = _untrustedValue;
        this._setIsDirty(true);
    }
    getInterval() {
        return this._dto.interval;
    }
    setInterval(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid interval");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("interval");
        this._requiredFieldsSetStatus.interval = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("interval", "Interval is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("interval", `Interval has exceeded the maximum length (${maxLength} chr).`));
            if (!this.isNew && _untrustedValue === this._dto.interval) {
                return;
            }
            this._dto.interval = _untrustedValue;
            this._setIsDirty(true);
        }
    }
    getTimeout() {
        return this._dto.timeout;
    }
    setTimeout(untrustedValue) {
        let _untrustedValue;
        this.clearError("timeout");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("timeout", "Timeout is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.timeout) {
            return;
        }
        this._dto.timeout = _untrustedValue;
        this._setIsDirty(true);
    }
    getAttachmentId() {
        return this._dto.attachmentId;
    }
    setAttachmentId(untrustedValue) {
        let _untrustedValue;
        this.clearError("attachmentId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("attachmentId", "Attachment Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.attachmentId) {
            return;
        }
        this._dto.attachmentId = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.beaconDatastore
                    .getAsync(id, expand);
                delete this._locationEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Beacon is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.beaconDatastore
                        .addAsync(dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.beaconDatastore
                        .updateAsync(dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Beacon cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.beaconDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.BeaconEntity = BeaconEntity;
//# sourceMappingURL=BeaconEntity.js.map